import myExecutionTask from "./my-execution-task";
import myCreatedTask from "./my-created-task";

export default {
    namespaced: true,
    state: () => ({
        collection : "MyExecutionTask",
        statuses: [
            { collection: "MyExecutionTask", value: "-1" },
            { collection: "MyCreatedTask", value: "-1" }
        ],
        searches: [
            { collection: "MyExecutionTask", value: null },
            { collection: "MyCreatedTask", value: null }
        ]
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        PUSH_STATUS (state, payload) {
            let status = state.statuses.find(x => x.collection == state.collection);

            if (status)
                status.value = payload;
        },
        PUSH_SEARCH (state, payload) {
            let search = state.searches.find(x => x.collection == state.collection);

            if (search)
                search.value = payload;
        }
    },
    getters: {
        getCollection: (s) => s.collection,
        getStatus: (s) => s.statuses.find(x => x.collection == s.collection)?.value ?? null,
        getSearch: (s) => s.searches.find(x => x.collection == s.collection)?.value ?? null,
    },
    modules: {
        myExecutionTask,
        myCreatedTask
    }
}